var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:[_vm.$style.buttonWrapper, _vm.buttonClass]},[(_vm.loading)?_c('div',{class:[_vm.$style.loader, _vm.loadingClass]},[_c('base-loader',{attrs:{"small":""}})],1):_c('button',_vm._b({class:_vm.classes,attrs:{"type":"button"},on:{"click":_vm.handleClick}},'button',_vm.$attrs,false),[_c('span',[_vm._t("default")],2)])])
}
var staticRenderFns = []

export { render, staticRenderFns }